import { CardStat } from "../cards/CardComps"
import { Grid, Paper, Pagination, Stack, Typography, CircularProgress } from "@mui/material"
import { TreeItem, TreeView } from "@mui/lab"
import { useState, useEffect } from "react"
import LoadingContent from "../common/LoadingContent"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import DoneIcon from "@mui/icons-material/Done"
import AccessTimeIcon from "@mui/icons-material/AccessTime"

const schedule = JSON.parse(`{
  "id": "123",
  "scheduleName": "ABC",
  "classesTotal": 48,
  "classesCompleted": 42,
  "classesCancelled": 4,
  "classesRemaining": 2,
  "batchId": "1234",
  "batchName": "Batch_ABC",
  "plannedStartDate": "",
  "plannedEndDate": "",
  "actualStartDate": "",
  "actualEndDate": "",
  "studentsTotal": 50,
  "pedagogue": "LECTURE",
  "crRemark": "Completed",
  "hodVerified": true,
  "classes": [
    {
      "topicId": "12345",
      "topic": "Topic_1",
      "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
      "numClassesAssigned": 5,
      "numClassesTaken": 4,
      "chapters": [
        {
          "chapterId": "123456",
          "chapter": "Chapter_1",
          "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
          "classes": [
            {
              "classId": "1234567",
              "className": "Class Name_1",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            },
            {
              "classId": "1234567",
              "className": "Class Name_2",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            }
          ]
        },
        {
          "chapterId": "123456",
          "chapter": "Chapter_2",
          "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
          "classes": [
            {
              "classId": "1234567",
              "className": "Class Name_3",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            },
            {
              "classId": "1234567",
              "className": "Class Name_4",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            }
          ]
        }
      ]
    },
    {
      "topicId": "12346",
      "topic": "Topic_2",
      "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
      "numClassesAssigned": 5,
      "numClassesTaken": 4,
      "chapters": [
        {
          "chapterId": "123456",
          "chapter": "Chapter_3",
          "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
          "classes": [
            {
              "classId": "1234567",
              "className": "Class Name_5",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            },
            {
              "classId": "1234567",
              "className": "Class Name_6",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            }
          ]
        },
        {
          "chapterId": "123456",
          "chapter": "Chapter_4",
          "status": "COMPLETED/IN_PROGRESS/NOT_STARTED",
          "classes": [
            {
              "classId": "1234567",
              "className": "Class Name_7",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            },
            {
              "classId": "1234567",
              "className": "Class Name_8",
              "teacherId": "1234567",
              "teacherName": "Teacher_1",
              "status": "COMPLETED/RESCHEDULED_COMPLETED/RESCHEDULED_NOT_STARTED/NOT_STARTED/CANCELLED",
              "plannedDate": "",
              "actualDate": "",
              "duration": "",
              "studentsAttended": 40
            }
          ]
        }
      ]
    }
  ]
}`)

const ClassesTab = ({ batchId }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pages, setPages] = useState(10)
  const [curPage, setCurPage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [limit, setLimit] = useState(6)
  const [totalCount, setTotalCount] = useState(0)

  const handlePageChange = (event, value) => {
    setCurPage(value)
  }

  return (
    <>
    <LoadingContent loading={loading}>
    {data?.length ? (<><Stack direction="row" gap={3} sx={{ pb: 4 }}>
          <CardStat tall label="Schedule Name" value={schedule.scheduleName} />
          <CardStat tall label="Total Students" value={schedule.studentsTotal} />
          <CardStat
            tall
            label="Classes"
            value={
              <Stack direction="row" gap={1}>
                {schedule.classesTotal -
                  schedule.classesRemaining +
                  "/" +
                  schedule.classesTotal}{" "}
                <CircularProgress
                  variant="determinate"
                  size={20}
                  thickness={8}
                  value={
                    ((schedule.classesTotal - schedule.classesRemaining) * 100) /
                    schedule.classesTotal
                  }
                  color="success"
                />
              </Stack>
            }
          />
          <CardStat tall label="HOD Verified" value={<DoneIcon />} />
          <CardStat tall label="CR Remark" value={schedule.crRemark} />
          <CardStat
            tall
            label="Planned Schedule"
            value="15 Nov, 22 - 30 Dec, 22"
          />
          <CardStat
            tall
            label="Actual Schedule"
            value="15 Nov, 22 - 30 Dec, 22"
          />
        </Stack>
        <TreeView
          defaultCollapseIcon={<ChevronRightIcon fontSize="large" />}
          defaultExpandIcon={<ExpandMoreIcon fontSize="large" />}
          disableSelection
        >
          {schedule.classes.map((c) => (
            <Topic data={c} />
          ))}
        </TreeView></>) : (
          <Typography sx={{ textAlign: "center", py: 5 }}>
            {"No records found"}
          </Typography>
        )}
      </LoadingContent>
      {!loading && !!totalCount && (
        <Stack
          direction="row"
          component={Paper}
          alignItems="center"
          justifyContent="space-between"
          sx={{
            position: "sticky",
            bottom: {
              xs: "3.8rem",
              sm: 0,
            },
            mt: 1,
            p: {
              xs: 1,
              sm: 2,
            },
            borderTop: 1,
            borderColor: "rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: 12,
                sm: 16,
              },
            }}
          >
            Showing ({(curPage - 1) * limit + 1} -{" "}
            {Math.min(curPage * limit, totalCount)}) of {totalCount} results
          </Typography>
          <Pagination
            count={pages}
            page={curPage}
            onChange={handlePageChange}
          />
        </Stack>
      )}
    </>
  )
}

const contentProps = {
  sx: {
    "&.Mui-focused": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}

const TreeNode = ({ progress, children }) => (
  <Stack
    direction="row"
    alignItems="center"
    gap={4}
    sx={{
      backgroundColor: "white",
      borderRadius: 2,
      px: 4,
      py: 1,
      my: 1,
      border: "2px rgba(0,0,0,0.1) solid",
    }}
  >
    <DoneIcon color="success" /> {children}
    {progress && (
      <CircularProgress
        variant="determinate"
        size={20}
        thickness={8}
        value={72}
        color="success"
        sx={{ ml: "auto" }}
      />
    )}
  </Stack>
)

const Class = ({ data }) => (
  <TreeItem
    nodeId={data.className}
    label={
      <TreeNode>
        <CardStat wAuto label="Class name" value={data.className} />
        <CardStat
          wAuto
          label="Date"
          value={
            <Stack direction="row" alignItems="center">
              15 Nov, 22
              <AccessTimeIcon sx={{ ml: 1.5, mr: 0.5 }} />2 hrs
            </Stack>
          }
        />
        <CardStat wAuto label="Teacher" value={data.teacherName} />
        <CardStat
          wAuto
          label="Attendance"
          value={data.studentsAttended + "/" + schedule.studentsTotal}
        />
      </TreeNode>
    }
    ContentProps={contentProps}
  />
)

const Chapter = ({ data }) => (
  <TreeItem
    nodeId={data.chapter}
    label={
      <TreeNode progress>
        <CardStat wAuto label="Chapter name" value={data.chapter} />
      </TreeNode>
    }
    ContentProps={contentProps}
  >
    {data.classes.map((c) => (
      <Class data={c} />
    ))}
  </TreeItem>
)

const Topic = ({ data }) => (
  <TreeItem
    nodeId={data.topic}
    label={
      <TreeNode progress>
        <CardStat wAuto label="Topic" value={data.topic} />
        <CardStat
          wAuto
          label="Classes"
          value={data.numClassesTaken + "/" + data.numClassesAssigned}
        />
      </TreeNode>
    }
    ContentProps={contentProps}
  >
    {data.chapters.map((d) => (
      <Chapter data={d} />
    ))}
  </TreeItem>
)

export default ClassesTab
